import { render } from "./OazisSuppliersMapPage.vue?vue&type=template&id=7db048b4&scoped=true"
import script from "./OazisSuppliersMapPage.vue?vue&type=script&lang=js"
export * from "./OazisSuppliersMapPage.vue?vue&type=script&lang=js"

import "./OazisSuppliersMapPage.vue?vue&type=style&index=0&id=7db048b4&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db048b4"]])

export default __exports__